import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgAssistDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 16 16',
};

export const SvgAssist = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <g transform="scale(0.8)">
        <path
          fill="#fff"
          stroke="currentColor"
          strokeWidth={1.25}
          d="M10 .625a9.375 9.375 0 1 1 0 18.75 9.375 9.375 0 0 1 0-18.75Z"
        />
        <path
          fill="currentColor"
          d="m11.917 14-.518-1.878H8.564L8.046 14H6l2.872-9h2.268L14 14zM8.97 10.659h2.021l-1.01-3.671z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
));
